export const ADD_EVENT_BLUEPRINT_LABEL_TEXT = {
    id: 'oe.accountAdmin.eventBlueprintToOrderBooking',
    defaultMessage: 'Add Event Blueprint to Order Booking',
    description: 'Label text',
};

export const NEW_BLUEPRINT_TEXT = {
    id: 'oe.accountAdmin.orderBooking.newBlueprint',
    defaultMessage: '{prefix}New Event Blueprint',
    description: 'Label text',
};

export const CREATE_EVENT_BLUEPRINT_TITLE_TEXT = {
    id: 'oe.blueprints.event.create.title',
    defaultMessage: 'New Event Blueprint',
    description: 'Popover header text',
};

export const ENTER_MAXIMUM_TEN_EMAILS = {
    id: 'oe.validation.email.mustBeMaxTenEmails',
    defaultMessage: 'Please enter a maximum of 10 email addresses',
    description: 'Text label',
};

export const ENTER_COMMA_SEPARATED_LIST_OF_EMAILS = {
    id: 'oe.emails.enterCommaSeparatedListOfEmails',
    description: 'Label text',
    defaultMessage: 'Please enter a comma-separated list of email addresses.',
};

export const INTERNAL_NOTIFICATION_EMAIL_HOVER_INFO = {
    id: 'oe.emails.infoTooltipHoverMessage',
    description: 'Label text',
    defaultMessage: `Any email recipients entered here will receive a notification when an event is booked via this booking form. 
For multiple recipients, please enter a comma-separated list.`,
};